import React from 'react'
import { LEVEL, LEVEL_NAMES } from './utils/constants/levels'
import { STATUS } from './utils/constants/statuses'
import { formatDisplayDate, calculateProgramExpirationDate } from './utils/displayUtils'
import LevelProgressPopover from './LevelProgressPopover'
import SuspensionWarningBar from './SuspensionWarningBar'
import { useMembershipJourneyContext } from './MembershipJourneyContext'
import {
  LevelProgressBar as StyledLevelProgressBar,
  LevelProgressContent,
  LevelProgressText,
  LevelProgressCount,
  DateInfo,
  DateLabel,
  DateValue,
  DateDivider,
  MobileBreak
} from './Styles/ProgressTracker.styles'

const LevelProgressBar = ({ activeLevel }) => {
  const { pgmProgress } = useMembershipJourneyContext()
  
  const isSuspended = pgmProgress?.isSuspended

  // If suspended, show suspension warning bar across all levels
  if (isSuspended) {
    return <SuspensionWarningBar />
  }

  if (activeLevel === LEVEL.QUALIFYING) {
    return null
  }
  
  const levelName = LEVEL_NAMES[activeLevel] || 'Level'
  
  const activeLevelData = pgmProgress?.levels?.find(l => l.key === activeLevel)
  
  if (!activeLevelData) {
    return null
  }
  
  const isCompleted = activeLevelData.status === STATUS.COMPLETE
  const { startDate, completionDate, expirationDate } = activeLevelData
  
  // For in-progress levels, show expiration date; for completed levels, show completion date
  let displayDate = isCompleted ? completionDate : expirationDate
  
  // Fallback: If expiration date is null for an in-progress level, calculate from Level 1 start date
  // This handles cases where users transition between curriculum versions (e.g., A1 -> FO3)
  if (!displayDate && !isCompleted) {
    displayDate = calculateProgramExpirationDate(pgmProgress?.levels, pgmProgress?.programType)
  }
  
  if (!displayDate) {
    return null
  }
  
  const formattedStartDate = formatDisplayDate(startDate)
  const formattedEndDate = formatDisplayDate(displayDate)
  
  return (
    <StyledLevelProgressBar>
      <LevelProgressContent>
        {isCompleted ? (
          <>
            <DateInfo>
              <DateLabel>{levelName} Started: </DateLabel>
              <DateValue>{formattedStartDate}</DateValue>
            </DateInfo>
            <DateDivider />
            <DateInfo>
              <DateLabel>{levelName} Completed: </DateLabel>
              <DateValue>{formattedEndDate}</DateValue>
            </DateInfo>
          </>
        ) : (
          <LevelProgressText>
            {levelName} Completion<MobileBreak /> Deadline: {' '}
            <LevelProgressCount>{formattedEndDate}</LevelProgressCount>
          </LevelProgressText>
        )}
      </LevelProgressContent>
      <LevelProgressPopover />
    </StyledLevelProgressBar>
  )
}

export default LevelProgressBar

